export default __webpack_public_path__ + "static/media/icon_eyes.1cc22d86.svg";